<template>
  <div class="company-form-preview">
    <Container width="medium" spacing="medium">
      <InvestorsHeader :investor="investor" :editable="editable" />
    </Container>

    <div class="mb-40">
      <Container width="medium" spacing="medium" border-top>
        <InvestorsDetails :investor="investor" />
      </Container>

      <Container width="medium" spacing="medium" border-top>
        <InvestorsInfo :investor="investor" />
      </Container>

      <Container width="medium" spacing="medium" border-top>
        <InvestorsFocusAreas :investor="investor" :max="4" />
      </Container>

      <Container
        v-if="investor.investments && investor.investments.length"
        width="medium"
        spacing="medium"
        border-top
        class="mb-30"
      >
        <InvestorsInvestments :investments="investor.investments" />
      </Container>

      <Container
        v-if="investor.keyPeople && investor.keyPeople.length"
        width="medium"
        spacing="medium"
        border-top
        class="mb-30"
      >
        <h2 class="fs40 pb-20 pb-md-40">Key people</h2>
        <b-row>
          <b-col
            v-for="person in investor.keyPeople"
            :key="person.id"
            lg="3"
            md="4"
            cols="6"
            class="mb-20"
          >
            <CardPerson :person="person" />
          </b-col>
        </b-row>
      </Container>

      <Container
        v-if="investor.sdgs && investor.sdgs.length"
        width="medium"
        spacing="medium"
        border-top
        class="mb-30"
      >
        <h2 class="fs40 pb-20 pb-md-40">Invests in SDGs</h2>

        <InvestorsSdgs :list="investor.sdgs" />
      </Container>

      <Container v-if="hasAbout" width="medium" spacing="medium" border-top>
        <h2 class="fs40 pb-20 pb-md-40">More about {{ investor.name }}</h2>

        <TextBlock class="mt-0">
          <div v-html="investor.about"></div>
        </TextBlock>
      </Container>

      <Container
        v-if="investor.contactPreferences && investor.contactPreferences.length"
        width="medium"
        spacing="medium"
        border-top
      >
        <h2 class="fs40 pb-20 pb-md-40">How to contact</h2>

        <TextBlock v-if="isLoggedIn" class="mt-0">
          <p
            v-if="contactPreferences.text && investor.contactText"
            class="pb-20"
          >
            {{ investor.contactText }}
          </p>

          <p v-if="contactPreferences.email && investor.contactEmail">
            Email:
            <a
              :href="'mailto:' + investor.contactEmail"
              @click="onContactClick"
              >{{ investor.contactEmail }}</a
            >
          </p>
          <p v-if="contactPreferences.phone && investor.contactPhone">
            Phone:
            <a :href="'tel:' + investor.contactPhone" @click="onContactClick">{{
              investor.contactPhone
            }}</a>
          </p>
          <p v-if="contactPreferences.website && investor.contactWebsite">
            Website:
            <a
              :href="investor.contactWebsite"
              target="_blank"
              @click="onContactClick"
              >{{ investor.contactWebsite }}</a
            >
          </p>

          <div v-if="hasSignupForm" class="pt-30">
            <button class="btn btn-primary" @click="$emit('apply')">
              Send pitch
            </button>
          </div>
        </TextBlock>

        <TextBlock v-else class="mt-0">
          <p>
            Sign up to get access to contact details or log in if you already
            have an account.
          </p>

          <div class="pt-30">
            <button
              type="button"
              class="btn btn-primary mr-30"
              @click="$eventBus.$emit('signup')"
            >
              Sign up
            </button>

            <button
              type="button"
              class="btn btn-link"
              @click="$eventBus.$emit('login')"
            >
              Login
            </button>
          </div>
        </TextBlock>
      </Container>

      <Container v-if="investor.claim" width="medium" spacing="medium">
        <TextBlock class="mt-0">
          <p class="pt-30">
            This profile is currently managed by The Hub,
            <button class="btn btn-link" @click="$emit('claim')">
              claim this profile here</button
            >.
          </p>
        </TextBlock>
      </Container>
    </div>
  </div>
</template>

<script>
import Container from '@/components/Container'
import CardPerson from '@/components/CardPerson'
import TextBlock from '@/components/TextBlock'
import InvestorsHeader from './InvestorsHeader'
import InvestorsDetails from './InvestorsDetails'
import InvestorsInfo from './InvestorsInfo'
import InvestorsInvestments from './InvestorsInvestments'
import InvestorsFocusAreas from './InvestorsFocusAreas'
import InvestorsSdgs from './InvestorsSdgs'

export default {
  name: 'InvestorsPageContent',
  components: {
    Container,
    CardPerson,
    TextBlock,
    InvestorsHeader,
    InvestorsDetails,
    InvestorsInfo,
    InvestorsInvestments,
    InvestorsFocusAreas,
    InvestorsSdgs
  },
  props: {
    editable: Boolean,
    investor: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasSignupForm() {
      return (
        this.investor.contactPreferences &&
        this.investor.contactPreferences.indexOf('signup') > -1
      )
    },
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
    hasAbout() {
      return (
        String(this.investor.about || '')
          .replace(/<[^>]*>?/gm, '')
          .trim().length > 0
      )
    },
    contactPreferences() {
      const obj = {}

      const preferences = this.investor.contactPreferences || []

      preferences.forEach((preference) => {
        obj[preference] = true
      })

      return obj
    }
  },
  methods: {
    onContactClick() {
      this.$gtm.push({
        event: 'ga.event',
        category: 'investor',
        action: 'InvestorContactClick'
      })

      this.$engagement({
        type: 'investor.contactClick'
      })
    }
  }
}
</script>
